import { render, staticRenderFns } from "./ProductServiceSeting.vue?vue&type=template&id=7ae4e37b&scoped=true"
import script from "./ProductServiceSeting.vue?vue&type=script&lang=js"
export * from "./ProductServiceSeting.vue?vue&type=script&lang=js"
import style0 from "./ProductServiceSeting.vue?vue&type=style&index=0&id=7ae4e37b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ae4e37b",
  null
  
)

export default component.exports